import { getField, updateField } from 'vuex-map-fields'

const getDefaultState = () => {
  return {
    count: 0,
    notifications: [],
    navigateToCommentTab: false,
    navigateToFinancialDescTab: false
  }
}
const state = getDefaultState()
const getters = {
  getField,
  getNotificationsCount: (state) => state.count,
  getNotificationValues: (state) => state.notifications,
  getNavigateToCommentTab: (state) => state.navigateToCommentTab,
  getNavigateToFinancialDescTab: (state) => state.navigateToFinancialDescTab
}
const mutations = {
  updateField,
  reset (state) {
    Object.assign(state, getDefaultState())
  },
  setNotificationsCount (state, payload) {
    state.count = payload.notificationsCount
  },
  SET_STORE_STATE (state, payload) {
    state[`${payload.stateName}`] = payload.value
  }
}

const actions = {
  async reset ({ commit }) {
    await commit('reset')
  },
  async setNotifications ({ state }, payload) {
    this.count = 0
    payload && payload.notifications.forEach((item) => {
      !item.seen && this.count++
    })
    state.count = this.count
  },
  async setNotificationValues ({ state }, payload) {
    if (payload.notificationValues && payload.notificationValues.details) {
      state.notifications = payload.notificationValues.details
    }
  },
  async updateNotification ({ state }, { notificationId }) {
    state.notifications.map((notification) => {
      if (notification._id === notificationId) {
        notification.seen = true
      }
    })
  }
}
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
